import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DetailsView from '../DetailsView';
import EventInputs from '../../../components/admin/forms/events/EventInputs';
import EventShow from '../../../components/admin/forms/events/EventShow';
import { MODELS } from '../../../constants/admin/settings';
import { create, update, fetchMember } from '../../../actions/admin/models/events';
import { BREADCRUMB } from '../../../constants/admin/breadcrumb';
import { withBreadcrumb } from '../../../components/admin/hocs/BreadcrumbWrapper';
import Tabs from '../AdminTabs';
import LineupEditor from './LineupEditor';
import EventContractShow from '../../../components/admin/forms/events/EventContractsShow';
import { hasPermissions, PERMISSIONS } from '../../../constants/authentication/permissions';
import { canAccessPerformanceInAdminSelector, currentUserSelector } from '../../../selectors/authentication';
import EventContractInputs from '../../../components/admin/forms/events/EventContractInputs';
import EventPartners from './EventPartners';
import EventArtists from './EventArtists';
import { formSetField } from '../../../actions/admin/forms';
import { modalFormSetField } from '../../../actions/admin/modal.forms';
import EventEmails from './EventEmails';
import EventChat from './EventChat';
import AdminModalForm from '../AdminModalForm';
import { fetchedSelector, fetchingSelector, formDataSelector } from '../../../selectors/admin/forms';
import {
    fetchEventReminders,
    createEventReminder,
    updateEventReminder,
    deleteEventReminders
} from '../../../actions/admin/models/event.reminders';
import AdminTable from '../AdminTable';
import { openModalForm, openModalFormWithData } from '../../../actions/admin/modal.forms';
import EventReminderInputs from '../../../components/admin/forms/events/EventReminderInputs';

class Details extends Component {
    componentDidMount() {
        this._fetch();
    }

    componentDidUpdate() {
        this._fetch();
    }

    _transformRows = {
        dueDate: date => `${date} days`
    };

    _fetch = () => {
        if (!this.props.fetching && !this.props.fetched && this.props.match.params.eventId) {
            this.props.fetchMember(this.props.match.params.eventId);
        }
    };

    _fetchEventReminders = () => {
        return this.props.fetchEventReminders(this.props.match.params.eventId);
    };

    _openEventReminderModal = item => {
        return this.props.openModalFormWithData(MODELS.EVENT_REMINDER, item);
    };

    _deleteEventReminder = () => {
        return this.props.deleteEventReminders(this.props.match.params.eventId);
    };

    _tabSwitch = () => {
        this.props.formSetField(false, 'fetchedDependencies');
        this.props.modalFormSetField(false, 'fetchedDependencies');
    };

    _tabLabels = () => {
        const labels = ['Details'];
        if (hasPermissions(this.props.user, PERMISSIONS.EVENT_EDIT)) {
            labels.push('Lineup');
        }
        if (this.props.event.chatEnabled && hasPermissions(this.props.user, PERMISSIONS.EVENT_EDIT)) {
            labels.push('Chat');
        }
        if (hasPermissions(this.props.user, PERMISSIONS.EVENT_EDIT)) {
            labels.push('Artists');
        }
        if (hasPermissions(this.props.user, PERMISSIONS.EVENTPARTNER_EDIT)) {
            labels.push('Media Partners');
        }
        if (hasPermissions(this.props.user, PERMISSIONS.CONTRACT_EDIT)) {
            labels.push('Contract Config');
        }
        if (hasPermissions(this.props.user, PERMISSIONS.EVENT_EDIT)) {
            labels.push('Email Config');
        }
        return labels;
    };

    _tabContent = () => {
        const content = [
            <DetailsView
                model={MODELS.EVENT}
                withShowMode={!!this.props.match.params.eventId}
                modelId={this.props.match.params.eventId}
                editView={EventInputs}
                showView={EventShow}
                updateAction={this.props.update}
                createAction={this.props.create}
            />
        ];
        if (hasPermissions(this.props.user, PERMISSIONS.EVENT_EDIT)) {
            content.push(<LineupEditor eventId={this.props.match.params.eventId} />);
        }
        if (this.props.event.chatEnabled && hasPermissions(this.props.user, PERMISSIONS.EVENT_EDIT)) {
            content.push(<EventChat eventId={this.props.match.params.eventId} />);
        }
        if (hasPermissions(this.props.user, PERMISSIONS.EVENT_EDIT)) {
            content.push(<EventArtists eventId={this.props.match.params.eventId} />);
        }
        if (hasPermissions(this.props.user, PERMISSIONS.EVENTPARTNER_EDIT)) {
            content.push(<EventPartners eventId={this.props.match.params.eventId} />);
        }
        if (hasPermissions(this.props.user, PERMISSIONS.CONTRACT_EDIT)) {
            content.push(
                <React.Fragment>
                    <DetailsView
                        model={MODELS.EVENT}
                        withShowMode={!!this.props.match.params.eventId}
                        fetchModel={this.props.fetchMember}
                        modelId={this.props.match.params.eventId}
                        editView={EventContractInputs}
                        showView={EventContractShow}
                        updateAction={this.props.update}
                    />
                    <div className="u-margin-top-1">
                        <AdminTable
                            model={MODELS.EVENT_REMINDER}
                            title="Reminders"
                            actionBarClassName="is-transparent"
                            className="u-margin-top-2"
                            fetchDataFunction={this._fetchEventReminders}
                            buttonAction={this.props.openModalForm}
                            transformFunctions={this._transformRows}
                            deleteAction={this._deleteEventReminder}
                            openItem={this._openEventReminderModal}
                        />
                    </div>
                    <AdminModalForm
                        model={MODELS.EVENT_REMINDER}
                        title="Add an automatic reminder"
                        modelId={this.props.match.params.eventId}
                        fields={EventReminderInputs}
                        createAction={this.props.createEventReminder}
                        updateAction={this.props.updateEventReminder}
                        staticData={{
                            hasAccessToPerformance:
                                this.props.hasAccessToPerformance && this.props.event.allowPerformanceContracts
                        }}
                    />
                </React.Fragment>
            );
        }
        if (hasPermissions(this.props.user, PERMISSIONS.EVENT_EDIT)) {
            content.push(<EventEmails eventId={this.props.match.params.eventId} />);
        }
        return content;
    };

    render() {
        return (
            <Tabs
                disable={!this.props.event.id}
                onTabSwitch={this._tabSwitch}
                labels={this._tabLabels()}
                content={this._tabContent()}
            />
        );
    }
}

const mapStateToProps = state => ({
    hasAccessToPerformance: canAccessPerformanceInAdminSelector(state),
    user: currentUserSelector(state),
    event: formDataSelector(state, { model: MODELS.EVENT }),
    fetched: fetchedSelector(state),
    fetching: fetchingSelector(state)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            create,
            modalFormSetField,
            formSetField,
            update,
            fetchMember,
            fetchEventReminders,
            createEventReminder,
            updateEventReminder,
            deleteEventReminders,
            openModalForm,
            openModalFormWithData
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withBreadcrumb(Details, () => [BREADCRUMB.EVENTS, BREADCRUMB.EVENTS_FORM]));



// WEBPACK FOOTER //
// ./src/containers/admin/events/Details.js